import {Pane, PaneGroupConfig} from "./pane";
import {PrimaryPaneComponent} from "../components/primary_pane_component";
import {PaneOptionComponent, PaneOptionComponentConfig} from "../components/pane_option_component";

export class PrimaryPane extends Pane {

    static new(parentElement, panesManager) {
        return new PrimaryPane(parentElement, panesManager);
    }

    constructor(id_or_element, panesManager) {
        super(id_or_element);
        this.group = PaneGroupConfig.primaryGroupCode;

        this.onBeforeBlurCallbacks.push(this.stopObservingPaneOptionViews.bind(this));
        this.onAfterFocusCallbacks.push(this.startObservingPaneOptionViews.bind(this));

        this.paneComponent = new PrimaryPaneComponent(this.element, this);
        this.panesManager = panesManager;

        this.paneOptionComponents = getPaneOptionComponents(this);
    }

    getNav() {
        if (!this.panesManager) return;
        return this.panesManager.nav;
    }

    getPanesManager() {
        return this.panesManager;
    }

    trackOpened() {
        let nav = this.getNav();
        if (nav && nav.rankersAnalyticsEventTracker && window.RankersAnalytics) {
            const backwardsCompatibilityOptions = {eventLabel: this.statsIdentifier}; // See tracker.js `getBackwardsCompatibilityParams()` function to understand this!
            const options = {nav_pane_id: this.statsIdentifier};
            nav.rankersAnalyticsEventTracker(window.RankersAnalytics.EventName.NAV_PANE_OPENED, {...backwardsCompatibilityOptions, ...options});
        }
    }

    // Stop observing the paneOptionComponents for stats impressions (views).
    stopObservingPaneOptionViews() {
        this.paneOptionComponents.forEach((paneOptionComponent)=>{
            paneOptionComponent.unobserveViewed();
        });
    }

    // Start observing the paneOptionComponents for stats impressions (views).
    startObservingPaneOptionViews() {
        this.paneOptionComponents.forEach((paneOptionComponent)=>{
            paneOptionComponent.observeViewed();
        });
    }

    // Count impressions withheld while the nav was shut (see `Nav#flushPendingImpressions`).
    flushPendingPaneOptionViews() {
        this.paneOptionComponents.forEach((paneOptionComponent)=>{
            paneOptionComponent.flushPendingViewed();
        });
    }
}

function getPaneOptionComponents(primaryPane) {
    let paneOptionComponents = [];
    const paneOptionElements = primaryPane.element.querySelectorAll(PaneOptionComponentConfig.selector);
    paneOptionElements.forEach((element)=>{
        let component = new PaneOptionComponent(element, primaryPane, primaryPane.panesManager);
        paneOptionComponents.push(component);
    });
    return paneOptionComponents;
}

